import { object, string } from 'yup'

import { i18nErrorCodes } from '../form-utils'

const { required } = i18nErrorCodes

export default object().shape({
  position:    string().required(required),
  company:     string().required(required),
  start:       string().required(required),
  end:         string().required(required),
  sector:      string().required(required),
})

export const emptyExperience = {
  position: '',
  company:  '',
  start:    '',
  end:      '',
  sector:   '',
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/experience.schema.ts